import { useCallback, useEffect, useState } from "react";
import camelcase from "camel-case";

export const useForgotFlow = (handleCurrentState, { params }) => {
  const [forgotFlowState, setForgotFlowState] = useState(
    params && params.tc
      ? {
          state: "resetQuestions",
          timecode: params.tc,
          uid: params.uid,
        }
      : { state: "entry", availableChannels: [], links: {} }
  );

  const onSubmit = async values => {
    await handleCurrentState(values, {
      forgotFlowState,
      setForgotFlowState,
    });
  };

  return {
    onSubmit,
    forgotFlowState,
    setForgotFlowState,
  };
};

export const useChannelSelection = (
  handleCurrentState,
  { forgotFlowState, setForgotFlowState }
) => {
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);

  const onSelectChannel = useCallback(
    async channel => {
      setSending(true);

      await handleCurrentState(channel, {
        forgotFlowState,
        setForgotFlowState,
      });

      setSending(false);
    },
    [forgotFlowState]
  );

  return {
    sending,
    onSelectChannel,
  };
};



// WEBPACK FOOTER //
// ./src/banking/authentication/ForgotFlow/hooks.js